// extracted by mini-css-extract-plugin
export var container = "HomeMoreResourcesWidget-module--container--e5760";
export var desktop = "HomeMoreResourcesWidget-module--desktop--edaab";
export var mobile = "HomeMoreResourcesWidget-module--mobile--05a0f";
export var section = "HomeMoreResourcesWidget-module--section--27a14";